import React from "react"
import Imgix from "react-imgix"
import PropTypes from "prop-types"
import { OutboundLink } from "gatsby-plugin-google-analytics"
const CustomHero = ({
  children,
  subchildren,
  body,
  image,
  calltagOpen,
  calltagClose,
  calltagbold,
  link,
}) => {
  let costDisplay = ""
  return (
    <div className="hero-block">
      <Imgix src={image} className="hero-block__image" />
      <div className="hero-block__content">
        <div className="hero-block__header"><h1>{children}</h1><h1>{subchildren}</h1></div>
        {costDisplay}
        <div className="hero-block__body t5"><p>{body}</p></div>
        <OutboundLink href={link} className="cta">
          Shop Now
        </OutboundLink>
        <div className="hero-block__call">
         {calltagOpen}<span>{calltagbold}</span> {calltagClose}
      </div>
      </div>
    </div>
  )
}

CustomHero.propTypes = {
  children: PropTypes.node.isRequired,
  subchildren: PropTypes.node.isRequired,
  calltagOpen: PropTypes.node.isRequired,
  calltagClose: PropTypes.node.isRequired,
  calltagbold: PropTypes.node.isRequired,
  cost: PropTypes.string,
  service: PropTypes.string,
  body: PropTypes.string.isRequired,
  notes: PropTypes.instanceOf(Array).isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string,
}

CustomHero.defaultProps = {
  cost: "",
  service: "",
  link: "",
}

export default CustomHero
